<ion-content *ngIf="true">
  <ion-modal class="simple-modal small-modal" [backdropDismiss]="dismissable" [isOpen]="isOpen">
    <ng-template efpKeyboardShortcut (escShortcut)="closeModal()">
      <ng-content> </ng-content>
    </ng-template> </ion-modal
></ion-content>
